<template lang="pug" src="./custom-sections.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      mobile: false
    }
  },
  created () {
    screen.width > 500 ? '' : this.mobile = true
  }
}
</script>



// WEBPACK FOOTER //
// custom-sections.vue?429fd648